import withAuth from './../../common/helper/auth-component.js';
import { connect } from 'react-redux';
import SelectSearch from 'react-select-search';
import { FormField, SelectField } from './../../common/helper/formFields';

import DataTable from 'react-data-table-component';
import React, { useState, useEffect } from 'react';
import DashboardService from '../../../services/dashboard-service.js';
import LoaderOverlay from './../../common/helper/loader.component.js';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import MerchantsService from "../../../services/merchants-service.js";
import { agentsList } from "./../../../actions/agent-actions.js";
import { useSelector, useDispatch } from 'react-redux';
import StatusBadge from '../../common/helper/transaction-status.component.js';
import { transactionSerachFormData , initialErrors, fieldValidation  } from '../../common/helper/form-constants.js';
import {transactionStatus, paymentMethods, transactionType} from '../../common/helper/status-constant.js';
import { duration } from 'moment';
import { MESSAGES } from '../../constants/constants.js';


const SystemSummary = () => { 
    const [loading, setLoading] = useState(false);
    const [activeButton, setActiveButton] = useState('Today'); // Initially active button is 'DAY'
    const [agents, setAgents] = useState([]);
    const [merchants, setMerchants] = useState([]);
    const [summary, setSummary]  = useState([]);
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        duration: 'today',
        agentID:null,
        customerID: null,
        from_date:getCurrentDate(),
        to_date: getCurrentDate()
     });

     const handleChangeSearch = (e) => {
        setFormData((prevData) => ({ ...prevData, ['agentID']: e }));
       // searchSystemSummary();

      }
      const handleChangeSearchMerchant = (e) => {
        setFormData((prevData) => ({ ...prevData, ['customerID']: e }));
       // searchSystemSummary();

      }
    const handleChange = (e) => {
      

        const { name, value } = e.target;
        console.log(name, value)
        setFormData((prevData) => ({ ...prevData, [name]: value }));
        //searchSystemSummary();
    }
    const searchSystemSummary = () => {
    
         setLoading(true);
        DashboardService.getSystemSummary(formData)
          .then(response => {
            const summary = response.data.data;
            console.log(summary)
            setSummary(summary)
            setLoading(false);
          })
          .catch(error => {
     
            setLoading(false);
          try {
            const errorMessage = error.response.data
            toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
          } catch (e){
            toast.error( MESSAGES.SERVER_ERROR)
          }
        })
    }
    const handleButtonClick = (buttonName) => {
      console.log(buttonName)
        setFormData((prevData) => ({ ...prevData, ['duration']: buttonName }));
        setActiveButton(buttonName);
       // searchSystemSummary();
      };

      const getAgents = () => {
        setLoading(true);
        dispatch(agentsList())
        .then((response) => {
          const agents = response.data.Active
          const arr = [{name:'All Agents',value:null}];
          for(var i=0; i<agents.length; i++) {
            arr.push({
              name: agents[i].full_name,
              value: agents[i].user_id,
            })
          }
          console.log(arr);
          setAgents(arr);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
       
      }
      
      const getMerchantsList = (e) => {
        setLoading(true);
        MerchantsService.getMerchants()
          .then(response => {
            const merchts = response.data.data;
            const arr = [{name:'All Merchants',value:null}];
            for(var i=0; i<merchts.length; i++) {
              if(merchts[i].merchant_detail.status_id == 'A') {
                arr.push({
                  name: merchts[i].merchant_detail.merchant_name,
                  value: merchts[i].merchant_detail.merchant_id,
                })
              }
              
            }
            setMerchants(arr);
            setLoading(false);
          })
          .catch(error => {
            setLoading(false);
            console.error("Error fetching agents:", error);
          });
      }
      function getCurrentDate() {
        const today = new Date();
        const year = today.getFullYear();
        let month = today.getMonth() + 1;
        let day = today.getDate();
      
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
      
        return `${year}-${month}-${day}`;
      }

      useEffect(() => {
        getAgents();
        getMerchantsList();
      },[])
      useEffect(() => {
       
       
          if (formData.agentID !== '' || formData.customerID !== '' || formData.duration !== '' || formData.from_date !='' || formData.to_date!='') {
            if(formData.duration == 'CUSTOM') {
              if (new Date(formData.from_date) > new Date(formData.to_date)) {
                toast.error('From Date should not be greater than to Date');
                return;
              }
            } 
             searchSystemSummary();
           
        }
        document.body.style.backgroundImage = '';

        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
    }, [formData]);
    
    return(

        <>
          <LoaderOverlay loading={loading} />
            <div className="container-fluid px-4" style={{paddingbottom:'30px'}}>
            <h4 className="updatename updatename1" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>System Summary</h4>
            <div className="container col-md-12" style={{paddingTop: '15px', paddingBottom: '10px', background: 'white', float:'left', marginBottom: '25px'}}>
            <div className="col-md-3" style={{padding: '0px', paddingRight: '30px'}}>
                   
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectSearch  value={formData.agentID}  search={true} options={agents} onChange={handleChangeSearch} name="toAgent" placeholder="All Agents" />
                    {/* <SelectField 
                       id="agentID"
                       isRequierd = {false}
                       name="agentID"
                       label="Agent"
                       selectedField = "All Agents"
                      
                       onChange={handleChange}
                     
                       options={agents}
                    /> */}
                    </div>
                  </div>
         <div className="col-md-3" style={{padding: '0px', paddingRight: '30px'}}>
                   
                   <div className="form-group frm" style={{textAlign: 'left'}}>
                   <SelectSearch search={true} options={merchants} onChange={handleChangeSearchMerchant}  value={formData.customerID} name="customerID" placeholder="All Merchants" />
                   {/* <SelectField 
                      id="customerID"
                      isRequierd = {false}
                      name="customerID"
                      label="Merchant"
                      selectedField = "All Merchants"
                     
                      onChange={handleChange}
                    
                      options={merchants}
                   /> */}
                   </div>          
                 </div>
            {activeButton == 'CUSTOM' && (
                <>
                 <div className="col-md-3" style={{padding: '0px', paddingRight: '30px'}}>
                   
                   <div className="form-group frm" style={{textAlign: 'left'}}>
                    
                   <FormField
                           type="date"
                           isRequierd = {false}
                           id="from_date"
                           name="from_date"
                           label="From Date"
                           placeholder = "From Date"
                          value={formData.from_date}
                           onChange={handleChange}
                          // error={errors.from_date}
                           max={getCurrentDate()}
                        />
                   </div>          
                 </div>

                 <div className="col-md-3" style={{padding: '0px', paddingRight: '30px'}}>
                   
                   <div className="form-group frm" style={{textAlign: 'left'}}>
                    
                   <FormField
                           type="date"
                           isRequierd = {false}
                           id="to_date"
                           name="to_date"
                           label="To Date"
                           placeholder = "To Date"
                           value={formData.to_date}
                           onChange={handleChange}
                          // error={errors.to_date}
                           max={getCurrentDate()}
                        />
                   </div>          
                 </div>
                </>
            )}
                
                </div>
            <div class="row">
            <div align="left" style={{textAlign:'center', marginBottom: '45px'}}>
            
                  <button style={{color:'green'}} type="sumbit" name="btn_asubmit" id="btn_asubmit"  className={`btn ddfg1 ${activeButton === 'Today' ? 'active' : ''}`} onClick={() => handleButtonClick('Today')}>DAY</button>
                  <button type="sumbit" name="btn_asubmit" id="btn_asubmit"  className={`btn ddfg1 ${activeButton === 'YESTERDAY' ? 'active' : ''}`} onClick={() => handleButtonClick('YESTERDAY')}>YESTERDAY</button>
                  <button type="sumbit" name="btn_asubmit" id="btn_asubmit"  className={`btn ddfg1 ${activeButton === 'WEEK' ? 'active' : ''}`}onClick={() => handleButtonClick('WEEK')}>WEEK</button>
                  <button type="sumbit" name="btn_asubmit" id="btn_asubmit" className={`btn ddfg1 ${activeButton === 'MONTH' ? 'active' : ''}`}  onClick={() => handleButtonClick('MONTH')}>MONTH</button>
                  <button type="sumbit" name="btn_asubmit" id="btn_asubmit"  className={`btn ddfg1 custom ${activeButton === 'CUSTOM' ? 'active' : ''}`} onClick={() => handleButtonClick('CUSTOM')}>CUSTOM</button>
                </div>
                
            </div>
            <div className="row">
          
          <div className="col-xl-12">
        
            <div className="row">
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">Total Transaction Count</p>
                        <hr />
                        <h4 className="mb-0">{summary.total_txn_count}</h4>
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">Pay In Count</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.payin_count}</h4>
                      </div>
                   
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium"> Pay Out Count</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.payout_count}</h4>
                      </div>
                  
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium"> Cancelled Transaction Count</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.cancelled_txn_count}</h4>
                      </div>
                  
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">Pay In Cancelled Transaction Count</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.payin_cancelled_txn_count}</h4>
                      </div>
                
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">Pay out Cancelled Transaction Count</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.payout_cancelled_txn_count}</h4>
                      </div>
                    
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium"> Failed Transaction Count</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.failed_txn_count}</h4>
                      </div>
                  
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium"> Pay In Failed Transaction Count</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.payin_failed_txn_count}</h4>
                      </div>
                
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">Pay Out Failed Transaction Count</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.payout_failed_txn_count}</h4>
                      </div>
                
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">Expired Transaction Count</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.expired_txn_count}</h4>
                      </div>
                    
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium"> Pay In Expired Transaction Count</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.payin_expired_txn_count}</h4>
                      </div>
                  
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium"> Pay Out Expired Transaction Count</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.payout_expired_txn_count}</h4>
                      </div>
                
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">Merchant Total Balance</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.merchants_total_balance}</h4>
                      </div>
                
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">Agent Total Balance</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.agents_total_balance}</h4>
                      </div>
                    
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium"> Total Hold Amount</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.total_hold_amount}</h4>
                      </div>
                  
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium"> Pool Balance</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.pool_balance}</h4>
                      </div>
                
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">Total Commission</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.total_commission}</h4>
                      </div>
                
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">Merchant Commission</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.merchant_commission}</h4>
                      </div>
                    
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium"> Agent Commission</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.agent_commission}</h4>
                      </div>
                  
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium"> Pool Commission</p>
                        <hr></hr>
                        <h4 className="mb-0">{summary.pool_commission}</h4>
                      </div>
                
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              {/* <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">System Balance</p>
                        <hr />
                        <h4 className="mb-0">{summary.total_txn_amount}</h4>
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">Total Transaction Amount</p>
                        <hr />
                        <h4 className="mb-0">{summary.total_txn_amount}</h4>
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium"> Pay In Amount</p>
                        <hr />
                        <h4 className="mb-0">{summary.payin_amount}</h4>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card mini-stats-wid">
                  <div className="card-body">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium"> Pay Out Amount</p>
                        <hr />
                        <h4 className="mb-0">{summary.payout_amount}</h4>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

          </>

    )
}

  
function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(SystemSummary));
